<template>
  <!-- 问答 -->
  <div class="container">
    <!-- 顶部导航栏 -->
    <HeadTab :typeindex="4" isshow="1"></HeadTab>
    <div class="obtain">
      <div class="quiz_inner">
        <div class="quiz_header">
          <div class="quiz_title">Вопросы и ответы</div>
          <div class="quiz_desc">
            Мы собрали ответы на самые распространённые вопросы о микрокредитах, <br>
            чтобы помочь вам быстро и удобно оформить заявку.
          </div>
        </div>
        <div class="quiz_list">
          <div v-for="(item, index) in quizList" :key="item.title" class="quiz_item"
            :class="{ 'quiz_item-open': activeIndex === index }">
            <div class="quiz_question" @click="toggleItem(index)">
              <div class="quiz_question-text">{{ item.title }}</div>
              <div class="quiz_icon" :class="{ 'quiz_icon-open': activeIndex === index }">
                {{ activeIndex === index ? '-' : '+' }}
              </div>
            </div>
            <div v-if="activeIndex === index" class="quiz_answer">
              <div v-for="line in item.answer" :key="line" class="quiz_answer-line">
                {{ line }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <BomTab :jumpindex="0" jumpurl="/quiz"></BomTab>
  </div>
</template>

<script>
  import HeadTab from '@/components/HeadTab.vue'
  import BomTab from '@/components/BomTab.vue'
  export default {
    name: "quiz",
    data() {
      return {
        activeIndex: -1,
        quizList: [{
            title: 'Как получить микрокредит?',
            answer: [
              '1.Для новых клиентов оформление микрокредита в Aicredit состоит из трёх простых шагов:',
              '2.Выберите сумму и срок микрокредита с помощью кредитного калькулятора и нажмите кнопку «Получить деньги».',
              '3.Зарегистрируйтесь и заполните короткую анкету, указав платёжные реквизиты для перечисления средств. Для этого необходимо указать ваш 20-значный IBAN-счёт, открытый в любом банке Республики Казахстан. Этот этап крайне важен, поскольку позволяет убедиться, что заявку оформляете именно вы, а не третьи лица, использующие ваши персональные данные.',
              '4.Дождитесь решения по заявке, подпишите договор с помощью SMS-кода и получите денежные средства на ваш IBAN-счёт.']},
          {
            title: 'Какие условия необходимо выполнить для получения микрокредита?',
            answer: [
              '• Гражданство Республики Казахстан;',
              '• Возраст от 18 до 65 лет;',
              '• Индивидуальный идентификационный номер (ИИН);',
              '• Личный банковский счёт и номер мобильного телефона.'
            ]
          },
          {
            title: 'Можно ли погасить микрокредит досрочно?',
            answer: [
              'Да, вы можете  погасить микрокредит досрочно. Информацию о текущей сумме к оплате можно посмотреть в личном кабинете либо обратиться в службу поддержки Aicredit по телефону +7 771 181 23 95.'
            ]
          },
          {
            title: 'Что будет, если не погасить микрокредит вовремя?',
            answer: [
              'Мы рекомендуем своевременно выполнять обязательства по договору микрокредита. Нарушение условий договора может привести к негативным финансовым последствиям и ухудшению вашей кредитной истории.',
              'Информация о микрокредите может быть передана в Первое кредитное бюро (ПКБ). Сведения о просроченной задолженности могут снизить ваш кредитный рейтинг и затруднить получение кредитов и займов в банках и других финансовых организациях в будущем.'
            ]
          }
        ]
      };
    },
    components: {
      BomTab,
      HeadTab
    },
    mounted() {},
    methods: {
      toggleItem(index) {
        this.activeIndex = this.activeIndex === index ? -1 : index;
      }
    },
  };
</script>

<style scoped>
  .obtain {
    background: #FFF8F6;
    padding: 0.63rem 1.58rem;
  }

  .quiz_inner {
    max-width: 6.83rem;
    margin: 0 auto;
  }

  .quiz_header {
    text-align: center;
    margin-bottom: 0.42rem;
  }

  .quiz_title {
    font-family: Inter, Inter;
    font-weight: bold;
    font-size: 0.25rem;
    color: #0B1C30;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin-bottom: 0.13rem;
  }

  .quiz_desc {
    font-family: Inter, Inter;
    font-weight: 400;
    font-size: 0.08rem;
    color: #5F5E5E;
    text-align: center;
    font-style: normal;
    text-transform: none;
  }

  .quiz_item {
    background: #FFFFFF;
    border-radius: 0.08rem;
    box-shadow: 0 0.01rem 0.02rem rgba(0, 0, 0, 0.03);
    margin-bottom: 0.06rem;
    overflow: hidden;
  }

  .quiz_item:last-child {
    margin-bottom: 0;
  }

  .quiz_question {
    padding: 0.13rem 0.26rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    box-sizing: border-box;
  }

  .quiz_question-text {
    flex: 1;
    font-family: Inter, Inter;
    font-weight: bold;
    font-size: 0.13rem;
    color: #0B1C30;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .quiz_icon {
    width: 0.1rem;
    height: 0.1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Inter, Inter;
    font-weight: 500;
    font-size: 0.2rem;
    color: #B02600;
    line-height: 1;
    flex-shrink: 0;
  }

  .quiz_answer {
    padding: 0 0.26rem 0.13rem;
  }

  .quiz_answer-line {
    font-family: Inter, Inter;
    font-weight: 400;
    font-size: 0.08rem;
    color: #5F5E5E;
    line-height: 0.13rem;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .quiz_answer-line:last-child {
    margin-bottom: 0;
  }

  @media screen and (max-width: 1200px) {
    .obtain {
      padding-left: 0.4rem;
      padding-right: 0.4rem;
    }
  }

  @media screen and (max-width: 768px) {
    .obtain {
      padding: 0.42rem 0.2rem 0.48rem;
    }

    .quiz_header {
      margin-bottom: 0.24rem;
    }

    .quiz_title {
      font-size: 0.24rem;
      line-height: 0.3rem;
    }

    .quiz_desc {
      font-size: 0.12rem;
      line-height: 0.2rem;
    }

    .quiz_question {
      min-height: 0.68rem;
      padding: 0.16rem;
      align-items: flex-start;
    }

    .quiz_question-text {
      font-size: 0.13rem;
      line-height: 0.2rem;
    }

    .quiz_answer {
      padding: 0 0.16rem 0.16rem;
    }

    .quiz_answer-line {
      font-size: 0.12rem;
      line-height: 0.2rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/quiz.vue